import React from 'react';

import Text from '../Text';
import Animated from '../Animated';
import { INotifyedContainer } from './interface';

import './styles.scss';

const NotifyedContainer: React.FC<INotifyedContainer> = ({
  className,
  children,
  notification,
}) => {

  const textNotification = () => {
    if (notification > 99)
      return '...';

    return notification <= 0 ? '' : notification;
  };

  return (
    <div className={`notification-container ${className || ''}`}>
      {children}
      <Animated
        show={notification > 0}
        animationIn="bounceIn"
        animationInDelay="fast"
        animationOut="zoomOut"
        animationOutDelay="faster"
        className="notification-counter"
      >
        <Text
          size={12}
          className="color-white font-bold"
          style={{ margin: notification > 99 ? '-8px 0 0 -1px' : 0 }}
        >
          {textNotification()}
        </Text>
      </Animated>
    </div>
  );
};

export default NotifyedContainer;
